module.exports = __webpack_public_path__ + "media/assets/images/icon_search@2x-1616fd5ab7c8473c2762fd7d433ee1fd.png";